import React from 'react'
import Table from './Components/Table/Table';


function AdminPanel() {
    return (
      <Table/>
    )
}

export default AdminPanel
